import { useNavigation } from '@react-navigation/native';
// eslint-disable-next-line import/order
import React, { useEffect, useState } from 'react';

import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Platform,
} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import Avatar from '@components/Avatar/Avatar';
import ChatPopup from '@components/Popups/ChatPopup';
import ProjectListPopup from '@components/Popups/ProjectListPopup';
import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';
import Overlay from '@components/Tutorialization/Overlay';
import { TutoralizationSetting } from '@graphql/generated';
import useMe from '@hooks/useMe';
import { useProjectTutorial } from '@hooks/useProjectTutorial';
import { getScaledSize, SCALED_DIMENSIONS } from '@themes/theme';
import { AsyncStorage } from '@utils/storage';

type MainHeaderProps = {
  location: 'Chats' | 'Projects' | 'My Tasks' | 'Activity' | 'Files';
};
const MainHeader: React.FC<MainHeaderProps> = ({ location }) => {
  const insets = useSafeAreaInsets();
  const navigation = useNavigation();

  const { me } = useMe();
  const { name, avatar } = me || { name: '' };
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [overlayVisible, setOverlayVisible] = useState<boolean>(false);
  const { isVisible, projectTutorialState } = useProjectTutorial();

  useEffect(() => {
    if (me?.email === 'user@example.com') {
      AsyncStorage.setItem('@tutoralizationAssignTask', '1');
      AsyncStorage.setItem('@tutoralizationTagMessage', '1');
      AsyncStorage.setItem('@tutoralizationHashtag', '1');
      return;
    }
    const tutoralizationAssignTask = me?.tutoralizationSetting?.find(
      (setting) => setting.settingType === TutoralizationSetting.AssignTask
    );
    const tutoralizationHashtag = me?.tutoralizationSetting?.find(
      (setting) => setting.settingType === TutoralizationSetting.Hashtag
    );
    const tutoralizationTagMessage = me?.tutoralizationSetting?.find(
      (setting) => setting.settingType === TutoralizationSetting.TagMessage
    );
    AsyncStorage.setItem(
      '@tutoralizationAssignTask',
      tutoralizationAssignTask?.close ? '1' : '0'
    );
    AsyncStorage.setItem(
      '@tutoralizationTagMessage',
      tutoralizationTagMessage?.close ? '1' : '0'
    );
    AsyncStorage.setItem(
      '@tutoralizationHashtag',
      tutoralizationHashtag?.close ? '1' : '0'
    );
  }, [me?.tutoralizationSetting]);

  useEffect(() => {
    const checkCurrentTutorialState = async () => {
      if (
        isVisible &&
        (projectTutorialState === '0' || projectTutorialState === '1')
      ) {
        setOverlayVisible(true);
        return;
      }
      setOverlayVisible(false);
    };
    checkCurrentTutorialState();
  }, [isVisible, projectTutorialState]);

  const renderPopup = () => {
    switch (location) {
      case 'Chats':
        return <ChatPopup closePopFn={() => setModalOpen(!modalOpen)} />;
      case 'Projects':
        return <ProjectListPopup closePopFn={() => setModalOpen(!modalOpen)} />;

      default:
        return null;
    }
  };

  return (
    <>
      <Overlay visible={overlayVisible} />
      <Modal
        animationType='fade'
        transparent={true}
        visible={modalOpen}
        onRequestClose={() => setModalOpen(false)}>
        <TouchableWithoutFeedback onPress={() => setModalOpen(!modalOpen)}>
          <Box style={styles.modal}></Box>
        </TouchableWithoutFeedback>
        <Box style={[styles.popUp, Platform.OS === 'android' && { top: 50 }]}>
          {renderPopup()}
        </Box>
      </Modal>
      <Box
        paddingHorizontal='m'
        paddingBottom='m'
        borderBottomColor='grey02'
        borderBottomWidth={location === 'My Tasks' ? 0 : 1}
        style={{ paddingTop: insets.top }}>
        <Box
          flexDirection='row'
          alignItems='center'
          justifyContent='space-between'
          marginTop='xs'>
          {location !== 'Chats' ? (
            <Text variant='heading1'>{location}</Text>
          ) : (
            <Icon
              name='Logo'
              width={106}
              height={getScaledSize(SCALED_DIMENSIONS.BUTTON_HEIGHT)}
              color='textPrimary'
            />
          )}

          <Box
            flexDirection='row'
            accessibilityLabel='Profile'
            alignItems='center'>
            <TouchableOpacity
              accessibilityLabel='Search'
              accessibilityRole='button'
              hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
              onPress={() => (navigation as any).navigate('global-search')}>
              <Box
                width={32}
                height={32}
                borderRadius='m'
                borderWidth={1}
                borderColor='grey02'
                backgroundColor='white'
                alignItems='center'
                justifyContent='center'
                marginRight='s'>
                <Icon name='Search' variant='s' color='textPrimary' />
              </Box>
            </TouchableOpacity>
            {location === 'Chats' && (
              <Icon
                name='MoreVertical'
                variant='l'
                color='textPrimary'
                marginRight='s'
                accessibilityLabel='Options button'
                onPress={() => {
                  setModalOpen(!modalOpen);
                }}
              />
            )}
            <TouchableOpacity
              onPress={() =>
                (navigation as any).navigate(
                  "subscription-p|| location === 'My Tasks'lan",
                  {
                    isSubscribe: true,
                  }
                )
              }></TouchableOpacity>
            {/* @ts-ignore */}
            <Avatar
              avatar={avatar}
              label={name}
              size='small'
              skipCache={true}
              accessibilityLabel='user-profile'
              onPress={() => (navigation as any).navigate('profile-stack')}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

const styles = StyleSheet.create({
  modal: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 99,
    height: Dimensions.get('window').height,
    backgroundColor: 'transparent',
    opacity: 1,
  },
  popUp: {
    zIndex: 100,
    position: 'absolute',
    top: 110, // Figma
    right: 16,
  },
});

export default MainHeader;
